<template>
	<div class="vvdi-universal-remote-series-list">
		<div class="vvdi-universal-remote-series-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">Professional Automotive Tools</span>
			</div>

			<div class="list">
				<p>
					Xhorse has successively spared no efforts to invest and develop automotive security technology, to provide superior professional and leading auto tools for the automotive service sector. We have developed the professional auto tools integrated with automotive inspection and OBD programming functions. We are also the first company globally developed the universal keyless entry vehicle remote. We incorporated a large number of dedicated transponders independently developed by Xhorse to our products, which tremendously improves the performance and stability of the Xhorse products.</p>

				<img :src="solution_image_01" alt="Xhorse"/>

				<p>
					Xhorse remotes help users immensely reduce inventory pressure, only 4 types of Xhorse remotes support over 3,000 car models.  We have XE Series Super Remote; XS Series Smartkey Remote; XN Series Wireless, and XK Series Wired Remote which can be generated and cloned for specialized security solutions on our VVDI series tools such as KEY TOOL MAX, MINI KEY TOOL, and KEY TOOL PLUS.</p>
			</div>
		</div>
	</div>
</template>

<script>

    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_professional_02.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01
            };
        }
    }

</script>

<style scoped="">
	.list > img {
		width: 100%;
	}

	.list p:first-child {
		margin-bottom: 2.75rem;
	}

	.list p:last-child {
		margin-top: 2.75rem;
	}

	.list p {
		width: 100%;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.75rem;
	}

	.list {
		width: 54.5rem;
		height: 34.5rem;
		margin-left: 7rem;
	}

	.vvdi-universal-remote-series-con {
		width: 61.5rem;
		height: 49rem;
		border: none;
		margin-left: 0px;
	}

	.vvdi-universal-remote-series-list {
		width: 100%;
		border: none;
		height: 49rem;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}

	.x-tit-con {
		font-size: 1.5rem;
		color: #3B3A38;
		line-height: 3.25rem;
	}

	.warnning {

		width: 100%;
		height: 100px;
		margin: 0 auto;
		text-align: center;
		font-style: oblique;
		font-size: 64px;
		font-family: "Open Sans";
		margin-top: 44px;
		margin-bottom: 44px;

	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-vvdi-universal-remote-series.vue